import { createMuiTheme } from '@material-ui/core/styles';
import {
  background,
  darkGrey,
  primaryLightest,
  primaryMain,
  secondaryMain,
} from './colors';
import { displayFont } from './tokens';

const heading = { fontFamily: displayFont, fontWeight: 700, letterSpacing: '-0.025em' };

// Sakura-Modern Material UI theme. src/index.js applies it as the root theme
// of modern builds only, so legacy builds keep the original theme.
const modernTheme = createMuiTheme({
  palette: {
    // Sakura-Modern --primary is pink: default buttons, focus outlines and
    // progress use it. Navy (primaryMain) stays for table heads and h1.
    primary: {
      main: secondaryMain,
    },
    secondary: {
      main: secondaryMain,
    },
    info: {
      main: '#00bdd1',
    },
    background: {
      default: background,
    },
  },
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    // Sakura-Modern components are mostly text-sm (14px): MUI's base size is
    // 14px and body1 is reduced to 14px so default Typography, menu items and
    // inputs match. Pages that set explicit sizes are unaffected.
    fontSize: 14,
    body1: { fontSize: '0.875rem', lineHeight: 1.43 },
    // Headings: DM Sans bold, tracking-tight (index.css h1-h6).
    h1: { ...heading, color: primaryMain, fontSize: 22 },
    h2: heading,
    h3: { ...heading, fontSize: 12 },
    h4: { ...heading, fontSize: 10 },
    h5: heading,
    h6: heading,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundColor: background,
        },
      },
    },
    MuiPaper: {
      root: {
        border: `1px solid ${darkGrey}22`,
      },
      rounded: {
        borderRadius: 8,
      },
    },
    MuiButton: {
      root: {
        borderRadius: 6,
        fontWeight: 700,
        letterSpacing: '0.01em',
        textTransform: 'none',
      },
    },
    // Sakura-Modern tabs and labels are sentence case.
    MuiTab: {
      root: {
        textTransform: 'none',
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: '#d8dfeb',
      },
    },
    MuiTableCell: {
      head: {
        backgroundColor: primaryMain,
        color: '#ffffff',
        fontWeight: 700,
      },
      root: {
        borderBottom: '1px solid #d8dfeb',
      },
    },
    MuiCardContent: {
      root: {
        background: primaryLightest,
        padding: 12,
        paddingTop: 16,
        "&:last-child": {
          paddingBottom: 12,
       },
      },
    },
  },
});

export default modernTheme;
